import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Table from "../../../../../../../common/element/Table";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import { getCompanyActivityLogs } from "../../../../../../../redux/Companies/companiesSlice";
import {
  selectCompanyActivityLogs,
  selectCompanyActivityLogsLoading,
  selectCompanyActivityLogsError,
  selectCompanyActivityLogsTotal // ✅ Newly added selector
} from "../../../../../../../redux/Companies/companiesSelector";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { Pagination } from "../../../../../../../common/pagination"; 
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";

const { Tr, Th, Td, THead, TBody } = Table;

const OnboardingActivity = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");

  // Pagination states
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [countData, setCountData] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // Redux selectors
  const activityData = useSelector(selectCompanyActivityLogs);
  const loading = useSelector(selectCompanyActivityLogsLoading);
  const error = useSelector(selectCompanyActivityLogsError);
  const totalRecords = useSelector(selectCompanyActivityLogsTotal); // ✅ Get total from redux

  // Fetch activity logs
  const fetchActivityLogs = useCallback(() => {
    if (companyId) {
      dispatch(
        getCompanyActivityLogs({
          companyId,
          page: filterpage,
          limit: filterlimit,
        })
      );
    }
  }, [dispatch, companyId, filterpage, filterlimit]);

  // Fetch on mount or when pagination/companyId changes
  useEffect(() => {
    fetchActivityLogs();
  }, [fetchActivityLogs]);

  // Update total pages when totalRecords changes
  useEffect(() => {
    const total = typeof totalRecords === "number" && totalRecords > 0
      ? totalRecords
      : activityData?.length || 0;

    setCountData(total);
    const pages = Math.max(1, Math.ceil(total / filterlimit));
    setTotalPages(pages);
  }, [totalRecords, activityData, filterlimit]);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  const currentPageCount = activityData?.length || 0;

  // Format date and time
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <ToolManagmentCard>
      <div className="pb-4 border-b border-gray-200">
        <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] text-start">
          Activity
        </h2>
      </div>

      <div className="py-6">
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <Table className="w-full text-sm text-gray-700">
            <THead>
              <Tr className="bg-[#F9F9FB]">
                <Th className="py-3 px-4 text-left font-medium font-lato not-italic text-[14px] leading-[150%] text-[#475467]">
                  Activity
                </Th>
                <Th className="py-3 px-4 text-left font-medium font-lato not-italic text-[14px] leading-[150%] text-[#475467]">
                  Edited by
                </Th>
                <Th className="py-3 px-4 text-left font-medium font-lato not-italic text-[14px] leading-[150%] text-[#475467]">
                  Date & Time
                </Th>
              </Tr>
            </THead>

            <TBody>
              {loading ? (
                <Tr >
                  <td colSpan={12} className="text-center"> 
                 <ThreeDotBouncingLoader/>

                  </td>
                </Tr>
              ) : error ? (
                <Tr>
                  <Td
                    colSpan={3}
                    className="text-center py-6 font-lato not-italic font-medium text-[14px] leading-[150%] text-red-600"
                  >
                    {error || "Failed to load activity logs"}
                  </Td>
                </Tr>
              ) : activityData && activityData.length > 0 ? (
                activityData.map((item) => (
                  <Tr
                    key={item.id || item._id}
                    className="border-t border-gray-100 hover:bg-gray-50 transition-colors text-start"
                  >
                    <Td className="py-3 px-4 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">
                      {item.activity || item.description || "N/A"}
                    </Td>
                    <Td className="py-3 px-4 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">
                      {item.performed_by?.first_name + " " + item.performed_by?.last_name || "N/A"}
                    </Td>
                    <Td className="py-3 px-4 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]">
                      {formatDateTime(item.dateTime || item.date_time || item.created_at)}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={3}
                    className="text-center py-6 font-lato not-italic font-medium text-[14px] leading-[150%] text-[#1D2939]"
                  >
                    No activity records found
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
        </div>
      </div>

      {/* ✅ Pagination Footer */}
      <div className="flex justify-between items-center mt-3">
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={currentPageCount}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </ToolManagmentCard>
  );
};

export default OnboardingActivity;